var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkIconSmallWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2105 13.2684L7.83333 13.049L7.45616 13.2684L2.93274 15.9002C2.87172 15.9176 2.8193 15.9161 2.78607 15.9078C2.76787 15.9033 2.75719 15.8973 2.75096 15.8928C2.75072 15.8926 2.75046 15.8925 2.7502 15.8923C2.75018 15.8902 2.75015 15.888 2.75013 15.8857L2.75 15.8333V5.5C2.75 4.49755 3.49755 3.75 4.5 3.75H11.1667C12.1691 3.75 12.9167 4.49755 12.9167 5.5V15.8333C12.9167 15.8749 12.9098 15.8973 12.9068 15.9052C12.9066 15.9056 12.9065 15.906 12.9063 15.9063C12.906 15.9065 12.9056 15.9066 12.9052 15.9068C12.8973 15.9098 12.8749 15.9167 12.8333 15.9167L12.781 15.9165C12.7732 15.9165 12.7668 15.9164 12.7615 15.9163L8.2105 13.2684Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIconSmallWhite);
export default __webpack_public_path__ + "static/media/bookmark_icon_small_white.11a63f4fac539bf2dc673531bcf802ed.svg";
export { ForwardRef as ReactComponent };